import {
  MasterDataViewModel,
  PriceListViewModel,
  PriceValueInput,
  QuotationType
} from '@/api/api';
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BModal,
  BForm,
  BCardText,
  BImg,
  BBadge
} from 'bootstrap-vue';
import { Vue, Component, Watch } from 'vue-property-decorator';
import ApiClientFactory from '@/api/apiClientFactory';
import InkjetThresholdFormModal from '@/components/prices/inkjetPrinting/InkjetThresholdFormModal.vue';
import InkjetAddPriceModel from '@/components/prices/inkjetPrinting/InkjetAddPriceModel.vue';

@Component({
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BForm,
    BCardText,
    BImg,
    BBadge,
    InkjetThresholdFormModal,
    InkjetAddPriceModel
  }
})
export default class InkjetPrintingPriceTab extends Vue {
  inkjetPrices: any = {};
  standeePricesUpdate: Array<{
    id: string;
    price: number;
  }> = [];

  areas: number[] = [];

  mounted() {
    this.fetchInjetPrintingPrice();
    this.standeePricesUpdate = [];
  }

  fetchInjetPrintingPrice() {
    const client = new ApiClientFactory().priceClient();

    client
      .getPrices(null, null, QuotationType.InkjetPrinting)
      .then((result) => {
        const groupByCategory = result.reduce((group, price) => {
          const { productName, width } = price;
          if (this.areas.indexOf(width) === -1) {
            this.areas.push(width);
          }

          group[productName!] = group[productName!] ?? [];
          group[productName!].push(price);
          return group;
        }, {});

        this.inkjetPrices = groupByCategory;
      });
  }

  sortAreaPrices(standeePrices: Array<PriceListViewModel>) {
    return [...standeePrices].sort(
      (a, b) => Math.abs(a.width) - Math.abs(b.width)
    );
  }

  sortAreas(areas: number[]) {
    return [...areas].sort((a, b) => Math.abs(a) - Math.abs(b));
  }

  formatArea(area: number) {
    if (area < 0) return `Dưới ${Math.abs(area)}m2`;
    return `Trên ${area}m2`;
  }

  changeStandeePrice(standeePriceItem) {
    const existIndex = this.standeePricesUpdate.findIndex(
      (s) => s.id === standeePriceItem.id
    );
    if (existIndex !== -1) {
      this.standeePricesUpdate[existIndex] = standeePriceItem.price;
    } else {
      this.standeePricesUpdate.push({
        id: standeePriceItem.id,
        price: standeePriceItem.price
      });
    }
  }

  submit(): void {
    const client = new ApiClientFactory().priceClient();

    const updatePricesmodel = this.standeePricesUpdate.map((s) => {
      return {
        id: s.id,
        width: 0,
        height: 0,
        price: s.price,
        minQuantity: 0,
        maxQuantity: 0,
        type: QuotationType.InkjetPrinting
      } as PriceValueInput;
    });
    client.updatePrices(updatePricesmodel).then(
      (result) => {
        if (result) {
          // show toast
          this.$bvToast.toast('Chỉnh sửa thành công', {
            title: 'Set giá catalouge',
            toaster: 'b-toaster-bottom-right',
            variant: 'success'
          });
          this.standeePricesUpdate = [];
          return;
        }

        this.$bvToast.toast('Chỉnh sửa thất bại', {
          title: 'Set giá catalouge',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger'
        });
      },
      (err) => {
        this.$bvToast.toast('Chỉnh sửa thất bại', {
          title: 'Set giá catalouge',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger'
        });
        console.log(err);
      }
    );
  }
}
